import { useEffect } from "react";

/** Registrácia firiem sa presunula na my.effzone.com (5. 11. 2026). */
const SIGNUP_URL = "https://my.effzone.com/start";

const SignupMoved = () => {
    useEffect(() => { window.location.replace(SIGNUP_URL); }, []);
    return (
        <p style={{ padding: 32, textAlign: "center" }}>
            Novú firmu založíte na <a href={SIGNUP_URL}>my.effzone.com</a>.
        </p>
    );
};

export default SignupMoved;
